import { Link } from 'react-router-dom';

const steps = [
  {
    number: '01',
    icon: 'ri-search-2-line',
    title: '选择服务',
    desc: '浏览服务列表，根据需求选择对应的查询类型，支持多种查询方式。',
    color: 'from-blue-500 to-blue-600',
    lightColor: 'bg-blue-50',
    iconColor: 'text-blue-600',
  },
  {
    number: '02',
    icon: 'ri-file-list-3-line',
    title: '提交订单',
    desc: '填写查询所需信息，完成在线支付，订单即刻生效开始处理。',
    color: 'from-indigo-500 to-indigo-600',
    lightColor: 'bg-indigo-50',
    iconColor: 'text-indigo-600',
  },
  {
    number: '03',
    icon: 'ri-checkbox-circle-line',
    title: '获取结果',
    desc: '专业团队快速处理，结果实时推送，安全加密保护您的隐私。',
    color: 'from-green-500 to-green-600',
    lightColor: 'bg-green-50',
    iconColor: 'text-green-600',
  },
];

const guarantees = [
  { icon: 'ri-shield-check-line', title: '数据安全', desc: '全程加密传输，严格保密' },
  { icon: 'ri-time-line', title: '快速出结果', desc: '平均3分钟内完成' },
  { icon: 'ri-customer-service-2-line', title: '专业客服', desc: '7×24小时在线支持' },
  { icon: 'ri-refund-2-line', title: '查不到退款', desc: '无结果全额退款保障' },
];

export default function HowToQuery() {
  return (
    <section className="py-14 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-blue-600 text-sm font-semibold mb-1 uppercase tracking-wider">How It Works</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">如何查询</h2>
          <p className="text-gray-500 text-sm">简单三步，快速获取结果</p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 relative">
          {/* Connector line desktop */}
          <div className="hidden md:block absolute top-10 left-[calc(16.67%+20px)] right-[calc(16.67%+20px)] h-px bg-gradient-to-r from-blue-300 via-indigo-300 to-green-300 z-0" />

          {steps.map((step) => (
            <div key={step.number} className="relative z-10 flex flex-col items-center text-center">
              {/* Icon circle */}
              <div className={`w-20 h-20 rounded-2xl bg-gradient-to-br ${step.color} flex items-center justify-center mb-5 relative`}>
                <i className={`${step.icon} text-white text-3xl`} />
                <span className="absolute -top-2 -right-2 w-6 h-6 bg-white rounded-full flex items-center justify-center text-xs font-bold text-gray-500 border border-gray-100">
                  {step.number}
                </span>
              </div>
              <h3 className="font-bold text-gray-900 text-lg mb-2">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed max-w-[220px]">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* Guarantee cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          {guarantees.map((g) => (
            <div key={g.title} className="bg-white rounded-xl p-4 flex flex-col items-center text-center border border-gray-100">
              <div className="w-10 h-10 flex items-center justify-center bg-blue-50 rounded-xl mb-3">
                <i className={`${g.icon} text-blue-600 text-xl`} />
              </div>
              <p className="font-semibold text-gray-800 text-sm mb-1">{g.title}</p>
              <p className="text-gray-400 text-xs">{g.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/help"
            className="inline-flex items-center gap-1 text-sm text-blue-600 hover:text-blue-700 font-medium cursor-pointer"
          >
            查看帮助中心了解更多 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
